// extracted by mini-css-extract-plugin
export default {"container":"appreciation-screen_container__Y6Aj+","title":"appreciation-screen_title__oiNgx"};